function StaticDot({ size = 14, color = "#ffffff", style = {} }: {
  size?: number; color?: string; style?: React.CSSProperties;
}) {
  return (
    <span
      style={{
        display: "inline-block",
        borderRadius: 9999,
        background: color,
        width: size,
        height: size,
        flexShrink: 0,
        ...style,
      }}
    />
  );
}

function DotI({ fs, color = "#ffffff" }: { fs: number; color?: string }) {
  const d = Math.round(fs * 0.14);
  return (
    <span style={{ position: "relative", display: "inline-block", lineHeight: 1 }}>
      <span>ı</span>
      <span style={{ position: "absolute", left: "50%", bottom: "62%", transform: "translateX(-50%)" }}>
        <StaticDot size={d} color={color} />
      </span>
    </span>
  );
}

export function Wordmark({
  fs = 22,
  weight = 800,
  color = "currentColor",
  dotColor = "#ffffff",
  tracking = "-0.05em",
  sepGap = 0.04,
  strokeEm = 0,
}: {
  fs?: number;
  weight?: number;
  color?: string;
  dotColor?: string;
  tracking?: string;
  sepGap?: number;
  strokeEm?: number;
}) {
  const sep = Math.round(fs * 0.13);
  return (
    <div
      style={{
        fontFamily: "'Space Grotesk', sans-serif",
        fontSize: fs,
        fontWeight: weight,
        letterSpacing: tracking,
        lineHeight: 1,
        display: "inline-flex",
        alignItems: "baseline",
        color,
      }}
    >
      <span>drpr</span>
      <span style={{ display: "inline-flex", alignSelf: "baseline", margin: `0 ${fs * sepGap}px` }}>
        <StaticDot size={sep} color={dotColor} />
      </span>
      <span>
        a<DotI fs={fs} color={dotColor} />
      </span>
    </div>
  );
}
